import { useEffect, useState } from "react";
import Logo from "./assets/logo.webp";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "./NavBar.scss";
import { NavLink } from "react-router-dom";

interface Iprops {
  active?: string;
  // Kept for existing callers; the redesigned bar is always white.
  background?: string;
}

const links = [
  { to: "/program-catalog", label: "Program Catalog", key: "catalog" },
  { to: "/about-us", label: "About Us", key: "about" },
  { to: "/resources", label: "Resources", key: "resources" },
  { to: "/gallery", label: "Gallery", key: "gallery" },
  { to: "/contact-us", label: "Contact Us", key: "contact" },
];

const NavBar = (props: Iprops) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`ss-nav ${scrolled ? "ss-nav--scrolled" : ""}`}>
      <Navbar collapseOnSelect expand="lg" className="ss-nav__bar">
        <div className="ss-nav__inner">
          <NavLink to={"/"} className="ss-nav__brand" aria-label="Skill Surf home">
            <img src={Logo} alt="Skill Surf Logo" width={155} height={51} />
          </NavLink>
          <Navbar.Toggle aria-controls="ss-nav-menu" className="ss-nav__toggle">
            <i className="bi bi-list" aria-hidden="true"></i>
          </Navbar.Toggle>
          <Navbar.Collapse id="ss-nav-menu">
            <Nav className="ss-nav__links ms-auto">
              {links.map((link) => (
                <NavLink
                  key={link.key}
                  to={link.to}
                  className={`ss-nav__link ${
                    props.active === link.key ? "is-active" : ""
                  }`}
                >
                  {link.label}
                </NavLink>
              ))}
              <a
                href="https://learnova.skillsurf.lk/"
                target="_blank"
                rel="noopener noreferrer"
                className="ss-nav__link"
              >
                Learnova
                <i className="bi bi-box-arrow-up-right ms-1" aria-hidden="true"></i>
              </a>
              <NavLink
                to={"/program-catalog"}
                className="ss-btn ss-btn--accent ss-btn--sm ss-nav__cta"
              >
                Explore Programs
              </NavLink>
            </Nav>
          </Navbar.Collapse>
        </div>
      </Navbar>
    </header>
  );
};

export default NavBar;
